export type CommonInputProps = {
  label?: string;
  placeholder?: string;
  error?: string | boolean;
  hint?: string;
  notice?: string;
};

export type BaseInputProps = CommonInputProps & {
  className?: string;
  disabled?: boolean;
  labelClassName?: string;
};

export const getCharacterCount = (
  value: string | number | undefined
): number => {
  if (value === undefined || value === null) {
    return 0;
  }
  return value.toString().length;
};

export const formatCharacterCounter = (
  current: number,
  limit: number
): string => {
  return `${current}/${limit}`;
};
